export enum ContractTypeEnums {
  Standard = 1,
  KooperationLight = 2,
  ProHolidays = 3,
}

export interface ContractType {
  id: number;
  title: string;
  is_default: boolean | null;
  /** RITA-1526: Logo als data:-URL. null = kein Logo; undefined = in dieser Abfrage nicht geladen. */
  logo_data_url?: string | null;
}
